export const FIRST_NAME_CANNOT_BE_EMPTY_MESSAGE = "First name can't be empty";
export const LAST_NAME_CANNOT_BE_EMPTY_MESSAGE = "Last name can't be empty";
export const EMAIL_CANNOT_BE_EMPTY_MESSAGE = "Email can't be empty";
export const INVALID_EMAIL_MESSAGE = 'Please enter a valid email address.';
export const ALL_REQUIRED_FIELDS_MESSAGE = 'Please make sure all required fields are not empty';